export const GET_MODULE = "get_module"
export const GET_MODULE_SUCCESSFUL = "get_module_successfull"
export const GET_MODULE_FAILED = "get_module_failed"
